let chameleon = parent.chameleon;

if (!chameleon) {
  chameleon = {
    // CHAMELEON_URL: 'https://chameleon-m-test-can-work.herokuapp.com',
    //CHAMELEON_URL: 'http://localhost:3000',
    // CHAMELEON_URL: 'http://localhost:3011',
  };
}

window.chameleon = chameleon;
window.hasRemote = () => !!chameleon.CHAMELEON_URL;

window.hasMode = mode => {
  const windowMode = window.mode || 'DEVELOPMENT';

  return mode === windowMode;
};
